import { useState } from "react";
import { useLang } from "../../core/lang";
import LangKeys from "../../core/locales/keys";
import LanguageModal from "./LanguageModal";

function SettingsHome({ setActiveTab }) {
  const { t, lang } = useLang();
  const [showLanguage, setShowLanguage] = useState(false);

  const languageMap = {
    en: t(LangKeys.english),
    hi: t(LangKeys.hindi),
    en_in: t(LangKeys.hinglish),
    gu: t(LangKeys.gujarati),
    mr: t(LangKeys.marathi),
    pa: t(LangKeys.punjabi),
    ta: t(LangKeys.tamil),
    te: t(LangKeys.telugu),
  };

  const items = [
    {
      icon: "🏢",
      title: t(LangKeys.business_settings),
      subtitle: t(LangKeys.business_settings_desc),
      onClick: () => setActiveTab("Business Profile"),
    },
    {
      icon: "🌐",
      title: t(LangKeys.language),
      subtitle: languageMap[lang] || "English",
      onClick: () => setShowLanguage(true),
    },
    {
      icon: "💬",
      title: t(LangKeys.whatsapp_service),
      subtitle: t(LangKeys.whatsapp_service_desc),
      onClick: () => setActiveTab("WhatsApp Credits"),
    },
    {
      icon: "💾",
      title: t(LangKeys.backup_information),
      subtitle: t(LangKeys.backup_information_desc),
      onClick: () => setActiveTab("Backup Information"),
    },
    {
      icon: "🎧",
      title: t(LangKeys.help_support_title) || "Help & Support",
      subtitle: t(LangKeys.help_center_subheading) || "24x7 AI Assistant, WhatsApp & Calling Helpline",
      onClick: () => setActiveTab("Help & Support"),
    },
    {
      icon: "🥇",
      title: t(LangKeys.premium_plans_title),
      subtitle: t(LangKeys.benefit_no_ads),
      onClick: () => setActiveTab("Premium Plans"),
    },
    {
      icon: "🗑️",
      title: t(LangKeys.delete_khata),
      subtitle: t(LangKeys.delete_khata_desc),
      onClick: () => setActiveTab("Delete Khata"),
    },
  ];

  return (
    <div style={styles.page}>
      <div style={styles.topCard}>
        <p style={styles.subText}>{t(LangKeys.settings_subtitle)}</p>
      </div>

      <div style={styles.card}>
        {items.map((item, index) => (
          <div key={item.title}>
            <div style={styles.row} onClick={item.onClick}>
              <div style={styles.left}>
                <div style={styles.iconWrap}>{item.icon}</div>

                <div>
                  <div
                    style={{
                      ...styles.title,
                      ...(item.danger ? styles.dangerText : {}),
                    }}
                  >
                    {item.title}
                  </div>
                  <div style={styles.subtitle}>{item.subtitle}</div>
                </div>
              </div>

              <div style={styles.arrow}>›</div>
            </div>

            {index !== items.length - 1 && <div style={styles.divider}></div>}
          </div>
        ))}
      </div>

      <div style={styles.footer}>
        {t(LangKeys.version)} 1.3.7
        <br />
        {t(LangKeys.copyright)}
      </div>

      {showLanguage && (
        <LanguageModal
          open={showLanguage}
          onClose={() => setShowLanguage(false)}
          onSaved={() => setShowLanguage(false)}
        />
      )}
    </div>
  );
}

const styles = {
  page: {
    padding: "16px",
  },

  topCard: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    padding: "20px",
    marginBottom: "16px",
    border: "1px solid #E2E8F0",
  },

  subText: {
    fontSize: "14px",
    color: "#6B7280",
  },

  card: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    border: "1px solid #E2E8F0",
    overflow: "hidden",
  },

  row: {
    height: "78px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 18px",
    cursor: "pointer",
  },

  left: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },

  iconWrap: {
    width: "42px",
    height: "42px",
    borderRadius: "50%",
    backgroundColor: "#F1F5F9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    flexShrink: 0,
  },

  title: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#111827",
  },

  subtitle: {
    fontSize: "13px",
    color: "#6B7280",
    marginTop: "3px",
  },

  dangerText: {
    color: "#B91C1C",
  },

  arrow: {
    fontSize: "24px",
    color: "#9CA3AF",
  },

  divider: {
    height: "1px",
    backgroundColor: "#F1F5F9",
  },

  footer: {
    textAlign: "center",
    fontSize: "13px",
    color: "#9CA3AF",
    marginTop: "24px",
    lineHeight: "22px",
  },
};

export default SettingsHome;